export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Регистрационные сведения"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сохранить"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтверждено"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Общедоступно"])}
}